"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsSnowplowReady = exports.SnowplowContext = void 0;
const react_1 = __importDefault(require("react"));
const useSnowplowTracker_1 = __importDefault(require("./hooks/useSnowplowTracker"));
exports.SnowplowContext = react_1.default.createContext({
    isSnowplowReady: false,
    hasPageViewFired: false,
    setHasPageViewFired: () => console.warn('SnowplowProvider not found or action not implemented'),
});
/**
 * Context Provider for Snowplow
 *
 * @param props all required and optional props for the Tracker initialization
 */
const SnowplowProvider = ({ configuration, children }) => {
    const isSnowplowReady = (0, useSnowplowTracker_1.default)(configuration);
    const [hasPageViewFired, setHasPageViewFired] = react_1.default.useState(false);
    const contextValue = react_1.default.useMemo(() => ({
        isSnowplowReady,
        hasPageViewFired,
        setHasPageViewFired,
    }), [isSnowplowReady, hasPageViewFired, setHasPageViewFired]);
    return react_1.default.createElement(exports.SnowplowContext.Provider, { value: contextValue }, children);
};
const useIsSnowplowReady = () => {
    const { isSnowplowReady } = react_1.default.useContext(exports.SnowplowContext);
    return isSnowplowReady;
};
exports.useIsSnowplowReady = useIsSnowplowReady;
exports.default = SnowplowProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU25vd3Bsb3dQcm92aWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC9Tbm93cGxvd1Byb3ZpZGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxrREFBMEI7QUFHMUIsb0ZBQTREO0FBWS9DLFFBQUEsZUFBZSxHQUFHLGVBQUssQ0FBQyxhQUFhLENBQXNCO0lBQ3BFLGVBQWUsRUFBRSxLQUFLO0lBQ3RCLGdCQUFnQixFQUFFLEtBQUs7SUFDdkIsbUJBQW1CLEVBQUUsR0FBRyxFQUFFLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxzREFBc0QsQ0FBQztDQUNsRyxDQUFDLENBQUM7QUFFSDs7OztHQUlHO0FBQ0gsTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLEVBQUUsYUFBYSxFQUFFLFFBQVEsRUFBaUIsRUFBZ0IsRUFBRTtJQUNsRixNQUFNLGVBQWUsR0FBRyxJQUFBLDRCQUFrQixFQUFDLGFBQWEsQ0FBQyxDQUFDO0lBQzFELE1BQU0sQ0FBQyxnQkFBZ0IsRUFBRSxtQkFBbUIsQ0FBQyxHQUFHLGVBQUssQ0FBQyxRQUFRLENBQVUsS0FBSyxDQUFDLENBQUM7SUFFL0UsTUFBTSxZQUFZLEdBQUcsZUFBSyxDQUFDLE9BQU8sQ0FDOUIsR0FBRyxFQUFFLENBQUMsQ0FBQztRQUNILGVBQWU7UUFDZixnQkFBZ0I7UUFDaEIsbUJBQW1CO0tBQ3RCLENBQUMsRUFDRixDQUFDLGVBQWUsRUFBRSxnQkFBZ0IsRUFBRSxtQkFBbUIsQ0FBQyxDQUMzRCxDQUFDO0lBRUYsT0FBTyw4QkFBQyx1QkFBZSxDQUFDLFFBQVEsSUFBQyxLQUFLLEVBQUUsWUFBWSxJQUFHLFFBQVEsQ0FBNEIsQ0FBQztBQUNoRyxDQUFDLENBQUM7QUFFSyxNQUFNLGtCQUFrQixHQUFHLEdBQVksRUFBRTtJQUM1QyxNQUFNLEVBQUUsZUFBZSxFQUFFLEdBQUcsZUFBSyxDQUFDLFVBQVUsQ0FBQyx1QkFBZSxDQUFDLENBQUM7SUFDOUQsT0FBTyxlQUFlLENBQUM7QUFDM0IsQ0FBQyxDQUFDO0FBSFcsUUFBQSxrQkFBa0Isc0JBRzdCO0FBRUYsa0JBQWUsZ0JBQWdCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../src/react/SnowplowProvider.tsx